import React, { useState } from "react";
import { CommandBarButton, ListActionButtonProps, TooltipHost } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { AuditListAside, OrderAuditType } from "../../../common/components/audit/AuditListAside";
import { OnPremOrderStatus } from "../../../common/types/OnPremOrderStatus";
import { useOrdersModuleApi } from "../../../common/useOrdersModuleApi";
import {
    allowedOnPremOrderStatuses,
    getAvailableOnPremOrderStatuses,
    mapOnPremOrderStatusName
} from "../../common/utils/getAvailableOnPremOrderStatuses";
import { OnPremOrderListingItem } from "../OnPremOrderListingItem";
import { OnPremOrderStatusDialog } from "./OnPremOrderStatusDialog";

enum OrderActions {
    AuditList,
    Status
}

type OnPremOrderActionsListingButtonProps = ListActionButtonProps<OnPremOrderListingItem>;

export const OnPremOrderActionsListingButton: React.VFC<OnPremOrderActionsListingButtonProps> = ({
    item
}: OnPremOrderActionsListingButtonProps) => {
    const [selectedStatus, setSelectedStatus] = useState<OnPremOrderStatus>();
    const [state, setState] = useState<OrderActions>();

    const availableStatuses = getAvailableOnPremOrderStatuses(item.status);

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdAdmin]}>
            <TooltipHost content="Additional">
                <CommandBarButton
                    icon="MoreVertical"
                    menuItems={[
                        {
                            text: "Status",
                            subMenuProps: {
                                items: allowedOnPremOrderStatuses.map((status) => ({
                                    text: mapOnPremOrderStatusName(status),
                                    onClick: () => {
                                        setSelectedStatus(status);
                                        setState(OrderActions.Status);
                                    },
                                    disabled: !availableStatuses.includes(status)
                                }))
                            }
                        },
                        {
                            text: "Additional",
                            subMenuProps: {
                                items: [
                                    {
                                        text: "Audit",
                                        onClick: () => setState(OrderActions.AuditList)
                                    }
                                ]
                            }
                        }
                    ]}
                />
            </TooltipHost>
            <ActionDialogManager
                status={state}
                selectedStatus={selectedStatus}
                item={item}
                onClose={() => setState(undefined)}
            />
        </AuthorizationWrapper>
    );
};

const ActionDialogManager = ({
    status,
    item,
    onClose,
    selectedStatus
}: {
    status?: OrderActions;
    selectedStatus?: OnPremOrderStatus;
    item: OnPremOrderListingItem;
    onClose: () => void;
}) => {
    const { getOnPremOrderAuditList } = useOrdersModuleApi();

    switch (status) {
        case OrderActions.AuditList:
            return (
                <AuditListAside
                    isOpen
                    itemId={item.id}
                    onClose={onClose}
                    getOrderAuditList={getOnPremOrderAuditList}
                    type={OrderAuditType.OnPrem}
                />
            );
        case OrderActions.Status:
            if (!selectedStatus) return <></>;
            return <OnPremOrderStatusDialog item={item} selectedStatus={selectedStatus} onClose={onClose} />;
        default:
            return <></>;
    }
};
